export default __webpack_public_path__ + "static/media/empty.100776dc.svg";